export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON aquarium CY.2c1ebf17.png";